// Single shared AUD display formatter for the frontend. Consolidates the
// hand-rolled `Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" })`
// instances that were duplicated across register pages, milestone/insurance
// tabs, the schedule drawer and dashboard metrics. Each formatter is
// instantiated once at module load (Intl.NumberFormat construction is costly)
// and reused. This is a display-only helper and is deliberately separate from
// financeCalc.ts's `formatAud`, which is the fixture-bound backend mirror and
// must not accrete display variants.
//
// Variants:
//   formatAud0dp     — whole-dollar figures, no cents (e.g. "$1,234")
//   formatAud2dp     — full precision with cents (e.g. "$1,234.50")
//   formatAudCompact — abbreviated notation (e.g. "$1.2M")

const formatter0dp = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const formatter2dp = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatterCompact = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  notation: "compact",
  maximumFractionDigits: 1,
});

/** Whole-dollar AUD, no cents (e.g. 1234.5 → "$1,235"). */
export function formatAud0dp(value: number): string {
  return formatter0dp.format(value);
}

/** Full-precision AUD with cents (e.g. 1234.5 → "$1,234.50"). */
export function formatAud2dp(value: number): string {
  return formatter2dp.format(value);
}

/** Abbreviated AUD in compact notation (e.g. 1_200_000 → "$1.2M"). */
export function formatAudCompact(value: number): string {
  return formatterCompact.format(value);
}
